(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m2-turbo-launch"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionRoot = (document.currentScript && document.currentScript.closest(".shopify-section")) || null;
  var SECTION_KEY = (sectionRoot && sectionRoot.id) ? sectionRoot.id : "m2-turbo-launch";
  function normalizeDesignMode() {
    if (window.Shopify && Shopify.designMode) {
      document.documentElement.classList.remove("m2-animate");
      return true;
    }
    return false;
  }

  // Add animations class only if we are really not in Theme Editor
  if (!normalizeDesignMode()) {
    document.documentElement.classList.add("m2-animate");
    // Shopify.designMode can be injected after scripts run; re-check a few times
    setTimeout(normalizeDesignMode, 0);
    setTimeout(normalizeDesignMode, 200);
    setTimeout(normalizeDesignMode, 800);
  }

  function forceVisible(root) {
    root = root || document;
    root.querySelectorAll(".m2-reveal").forEach(function (el) {
      el.classList.add("is-visible");
      el.style.opacity = "1";
      el.style.transform = "none";
    });
  }

  function setDelays(root) {
    (root || document).querySelectorAll(".m2-kol-grid, .m2-review-wall-scroll").forEach(function (container) {
      Array.prototype.forEach.call(container.querySelectorAll(".m2-reveal"), function (el, idx) {
        el.style.setProperty("--m2-delay", (idx * 0.2) + "s");
      });
    });
  }

  function initHeaderGlowGate() {
    var header = document.querySelector(".header--moprobo-m2-home");
    if (!header) return;

    var section2 = document.getElementById("performance");
    var section4 = document.getElementById("authority");
    if (!section2 || !section4) return;

    var ticking = false;
    var lastY = window.scrollY || 0;

    function isActive() {
      var y = window.scrollY || 0;
      var start = section2.getBoundingClientRect().top + y;
      var end = section4.getBoundingClientRect().top + y + section4.offsetHeight;
      var headerH = header.offsetHeight || 0;
      var probe = y + headerH + 10;
      return probe >= start && probe <= end;
    }

    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var scrollingUp = y < lastY;
      lastY = y;

      // Home fallback sticky: always pin, hide on down, show on up.
      header.classList.add("m2-home-force-sticky");
      if (y <= 6 || scrollingUp) header.classList.remove("m2-home-hidden");
      else header.classList.add("m2-home-hidden");

      if (isActive()) header.classList.add("m2-glow-active");
      else header.classList.remove("m2-glow-active");
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  function initMobileComparisonToggle(root) {
    root = root || document;
    var performance = root.querySelector("#performance") || document.getElementById("performance");
    if (!performance) return;

    var items = performance.querySelectorAll(".m2-comparison-item");
    if (!items.length) return;

    var mobileMq = window.matchMedia("(max-width: 639px)");
    function clearAllActive() {
      items.forEach(function (item) {
        item.classList.remove("is-active");
      });
      performance.classList.remove("m2-comparison-has-active");
    }

    function activateItem(target) {
      items.forEach(function (item) {
        item.classList.toggle("is-active", item === target);
      });
      performance.classList.add("m2-comparison-has-active");
    }

    function syncActiveState() {
      var hasActive = Array.prototype.some.call(items, function (item) {
        return item.classList.contains("is-active");
      });
      performance.classList.toggle("m2-comparison-has-active", hasActive);
    }

    // Re-init safely in Theme Editor hot reloads.
    window.__m2ComparisonObservers = window.__m2ComparisonObservers || {};
    if (window.__m2ComparisonObservers[SECTION_KEY]) {
      try { window.__m2ComparisonObservers[SECTION_KEY].disconnect(); } catch (e) {}
      delete window.__m2ComparisonObservers[SECTION_KEY];
    }

    if (!mobileMq.matches) {
      clearAllActive();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = entry.target;
        if (entry.isIntersecting) return;

        item.classList.remove("is-active");
        syncActiveState();
      });
    }, {
      threshold: [0.25, 0.45, 0.7]
    });

    var comparisonTouchSwitchTimer = null;
    items.forEach(function (item) {
      if (item.dataset.m2TouchSwitchBound !== "1") {
        item.addEventListener("touchend", function () {
          if (!mobileMq.matches) return;
          if (comparisonTouchSwitchTimer) clearTimeout(comparisonTouchSwitchTimer);
          comparisonTouchSwitchTimer = setTimeout(function () {
            comparisonTouchSwitchTimer = null;
            activateItem(item);
          }, 600);
        }, { passive: true });
        item.dataset.m2TouchSwitchBound = "1";
      }
      observer.observe(item);
    });
    window.__m2ComparisonObservers[SECTION_KEY] = observer;
  }

  function initPhotoWallMobileCarousel(root) {
    root = root || document;
    var reviews = root.querySelector("#reviews") || document.getElementById("reviews");
    if (!reviews) return;

    var scroller = reviews.querySelector(".m2-review-wall-scroll.photo-wall-scroll");
    if (!scroller) return;
    if (scroller.dataset.m2PhotoWallMobileBound === "1") return;
    scroller.dataset.m2PhotoWallMobileBound = "1";

    var cards = Array.prototype.slice.call(scroller.querySelectorAll(".photo-wall-item"));
    if (!cards.length) return;

    var mq = window.matchMedia("(max-width: 639px)");

    var raf = null;
    var settling = false;
    var activeIdx = 0;
    var stopInProgress = false;

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    function getNearestIndex() {
      var viewportCenter = scroller.scrollLeft + scroller.clientWidth / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var center = card.offsetLeft + card.clientWidth / 2;
        var d = Math.abs(center - viewportCenter);
        if (d < bestDist) {
          bestDist = d;
          bestIdx = i;
        }
      }
      return bestIdx;
    }

    function getCenteredLeft(idx) {
      var card = cards[idx];
      if (!card) return scroller.scrollLeft;
      return card.offsetLeft - (scroller.clientWidth - card.clientWidth) / 2;
    }

    function applyStackTransforms() {
      raf = null;
      if (!mq.matches) {
        cards.forEach(function (card) {
          card.style.transform = "";
          card.style.opacity = "";
          card.style.zIndex = "";
          card.style.boxShadow = "";
        });
        return;
      }

      var viewportCenter = scroller.scrollLeft + scroller.clientWidth / 2;

      // Use card width as a rough "one step" for normalization.
      var step = (cards[0] && cards[0].clientWidth) ? (cards[0].clientWidth * 0.9) : 1;

      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var center = card.offsetLeft + card.clientWidth / 2;
        var dx = center - viewportCenter; // +right, -left
        var adx = Math.abs(dx);

        // closeness: 1 (center) -> 0 (far)
        var closeness = 1 - clamp(adx / (step * 3.2), 0, 1);

        var pop = settling ? 1 : 0.92;
        closeness = clamp(closeness * pop, 0, 1);
        closeness = Math.pow(closeness, 0.55);

        // Perspective feel: far cards smaller + slightly rotated.
        var scale = 0.82 + 0.18 * closeness;
        var ty = 10 - 28 * closeness; // faster / stronger lift for main card
        var tz = -20 + 70 * closeness; // subtle depth
        var rotY = clamp(dx / (step * 2.8), -1, 1) * -8 * (1 - closeness);
        var opacity = 0.2 + 0.8 * closeness;

        card.style.transform =
          "perspective(900px) rotateY(" + rotY.toFixed(2) + "deg) translate3d(0," + ty.toFixed(1) + "px," + tz.toFixed(1) + "px) scale(" + scale.toFixed(3) + ")";
        card.style.opacity = opacity.toFixed(3);
        card.style.zIndex = String(Math.round(1000 * closeness));
        if (i === activeIdx) {
          card.style.boxShadow = "0 18px 40px rgba(0, 0, 0, 0.18)";
        } else if (closeness > 0.55) {
          card.style.boxShadow = "0 12px 28px rgba(0, 0, 0, 0.12)";
        } else {
          card.style.boxShadow = "0 6px 18px rgba(0, 0, 0, 0.08)";
        }
      }
    }

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(applyStackTransforms);
    }

    scroller.addEventListener("scroll", function () {
      if (!mq.matches) return;
      settling = false;
      schedule();
    }, { passive: true });
    window.addEventListener("resize", schedule);

    function onScrollEnd() {
      if (!mq.matches) return;
      if (stopInProgress) return;
      stopInProgress = true;
      activeIdx = getNearestIndex();
      settling = true;
      schedule();
      window.setTimeout(function () {
        settling = false;
        schedule();
        stopInProgress = false;
      }, 120);
    }

    scroller.addEventListener("scrollend", onScrollEnd);

    function onMqChange() {
      if (!mq.matches) {
        scroller.scrollLeft = 0;
        applyStackTransforms();
      } else {
        schedule();
      }
    }

    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);

    // Center the first card on initial load (mobile only).
    if (mq.matches) {
      window.setTimeout(function () {
        scroller.scrollLeft = getCenteredLeft(0);
        activeIdx = 0;
        applyStackTransforms();
      }, 0);
    } else {
      applyStackTransforms();
    }
  }

  // Mobile exploded hotspots: revert to original (title-only tooltips, no custom click positioning)

  function initReveal(root) {
    root = root || document;
    var reveals = root.querySelectorAll(".m2-reveal");
    if (!reveals.length) return;

    setDelays(root);

    // In Theme Editor, sections can hot-reload without re-running JS.
    // Force content visible to avoid "everything disappears" while editing.
    if (window.Shopify && Shopify.designMode) {
      forceVisible(root);
      return;
    }

    var lastScrollY = window.scrollY || 0;
    var scrollDirection = "down";

    window.addEventListener("scroll", function () {
      var currentY = window.scrollY || 0;
      scrollDirection = currentY >= lastScrollY ? "down" : "up";
      lastScrollY = currentY;

      if (scrollDirection === "up") {
        reveals.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.top >= window.innerHeight * 0.85) {
            el.classList.remove("is-visible");
          }
        });
      }
    }, { passive: true });

    if (!("IntersectionObserver" in window)) {
      reveals.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    // Disconnect previous observer for this section (if any)
    if (window.__m2RevealObservers && window.__m2RevealObservers[SECTION_KEY]) {
      try { window.__m2RevealObservers[SECTION_KEY].disconnect(); } catch (e) {}
    }
    window.__m2RevealObservers = window.__m2RevealObservers || {};

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && scrollDirection === "down") {
          entry.target.classList.add("is-visible");
        }
      });
    }, {
      threshold: 0.18,
      rootMargin: "0px 0px -8% 0px"
    });

    window.__m2RevealObservers[SECTION_KEY] = observer;
    reveals.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initial run
  initReveal(sectionRoot || document);
  initHeaderGlowGate();
  initMobileComparisonToggle(sectionRoot || document);
  initPhotoWallMobileCarousel(sectionRoot || document);

  // Extra safety for Theme Editor: when any block/image setting changes, Shopify can morph the DOM.
  // Observe and re-apply visibility so screens don't "disappear" mid-edit.
  if (window.Shopify && Shopify.designMode && sectionRoot && window.MutationObserver) {
    try {
      var mo = new MutationObserver(function () {
        forceVisible(sectionRoot);
        setDelays(sectionRoot);
      });
      mo.observe(sectionRoot, { subtree: true, childList: true, attributes: true });
      window.__m2MutationObservers = window.__m2MutationObservers || {};
      window.__m2MutationObservers[SECTION_KEY] = mo;
      forceVisible(sectionRoot);
    } catch (e) {}
  }

  // Theme Editor hot reload hooks
  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    if (sectionRoot && event.target === sectionRoot) {
      initReveal(event.target);
      initMobileComparisonToggle(event.target);
      initPhotoWallMobileCarousel(event.target);
    }
  });
  document.addEventListener("shopify:section:select", function (event) {
    if (!event || !event.target) return;
    if (sectionRoot && event.target === sectionRoot) {
      initReveal(event.target);
      initMobileComparisonToggle(event.target);
      initPhotoWallMobileCarousel(event.target);
    }
  });
})();

(function () {
  var sections = document.querySelectorAll("[data-m2-kol-section]");
  if (!sections.length) return;

  function initKolMobileCarousel(sectionEl) {
    var grid = sectionEl.querySelector(".m2-kol-grid");
    var dots = sectionEl.querySelectorAll("[data-m2-kol-dot]");
    if (!grid || !dots.length) return;
    if (grid.dataset.m2KolCarouselBound === "1") return;
    grid.dataset.m2KolCarouselBound = "1";

    var slides = grid.querySelectorAll(".m2-kol-card");
    if (!slides.length) return;

    var mq = window.matchMedia("(max-width: 639px)");
    var scrollRaf = null;

    function setActiveIndex(i) {
      var max = dots.length - 1;
      i = Math.max(0, Math.min(max, i));
      dots.forEach(function (dot, j) {
        var on = j === i;
        dot.setAttribute("aria-selected", on ? "true" : "false");
        dot.tabIndex = on ? 0 : -1;
      });
    }

    function readIndexFromScroll() {
      var maxIdx = slides.length - 1;
      if (maxIdx <= 0) return 0;

      var viewportCenter = grid.scrollLeft + grid.clientWidth / 2;
      var bestIdx = 0;
      var bestDist = Infinity;

      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        var d = Math.abs(slideCenter - viewportCenter);
        if (d < bestDist) {
          bestDist = d;
          bestIdx = i;
        }
      }

      return Math.max(0, Math.min(maxIdx, bestIdx));
    }

    function syncDotsFromScroll() {
      if (!mq.matches) return;
      setActiveIndex(readIndexFromScroll());
    }

    function onScrollTick() {
      scrollRaf = null;
      syncDotsFromScroll();
    }

    function scrollToIndex(i) {
      var slide = slides[i];
      if (!slide) return;
      if (!mq.matches) return;
      var left = slide.offsetLeft - (grid.clientWidth - slide.clientWidth) / 2;
      grid.scrollTo({ left: left, behavior: "smooth" });
      setActiveIndex(i);
    }

    grid.addEventListener(
      "scroll",
      function () {
        if (!mq.matches) return;
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(onScrollTick);
      },
      { passive: true }
    );

    grid.addEventListener("scrollend", syncDotsFromScroll);

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var idx = parseInt(dot.getAttribute("data-m2-kol-dot"), 10);
        if (isNaN(idx)) return;
        scrollToIndex(idx);
      });
    });

    function onResize() {
      syncDotsFromScroll();
    }

    window.addEventListener("resize", onResize);

    function onMqChange() {
      if (!mq.matches) {
        grid.scrollLeft = 0;
        setActiveIndex(0);
      } else {
        syncDotsFromScroll();
      }
    }

    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);

    syncDotsFromScroll();
  }

  function ensureInstagramScript() {
    if (window.instgrm) return;
    if (document.querySelector('script[src="//www.instagram.com/embed.js"]')) return;
    var script = document.createElement("script");
    script.async = true;
    script.src = "//www.instagram.com/embed.js";
    document.body.appendChild(script);
  }

  function ensureTikTokScript() {
    if (window.tiktokEmbedLoaded) return;
    if (document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) return;
    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.tiktok.com/embed.js";
    script.onload = function () {
      window.tiktokEmbedLoaded = true;
    };
    document.body.appendChild(script);
  }

  function parseVideo(url) {
    if (!url) return null;
    var clean = String(url).trim();
    if (!clean) return null;

    var instagramMatch = clean.match(/instagram\.com\/(?:reel|p)\/([A-Za-z0-9_-]+)/i);
    if (instagramMatch) {
      return {
        type: "instagram",
        id: instagramMatch[1]
      };
    }

    var tikTokMatch = clean.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/i);
    if (tikTokMatch) {
      return {
        type: "tiktok",
        id: tikTokMatch[1]
      };
    }

    return {
      type: "iframe",
      url: clean
    };
  }

  sections.forEach(function (sectionEl) {
    var lightbox = sectionEl.parentElement.querySelector("[data-m2-kol-lightbox]");
    var embed = lightbox ? lightbox.querySelector("[data-m2-kol-embed]") : null;
    var closeBtn = lightbox ? lightbox.querySelector("[data-m2-kol-close]") : null;
    if (!lightbox || !embed || !closeBtn) return;

    function closeLightbox() {
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      embed.innerHTML = "";
      document.body.style.overflow = "";
    }

    function openLightbox(url) {
      var parsed = parseVideo(url);
      if (!parsed) return;

      embed.innerHTML = "";

      if (parsed.type === "instagram") {
        ensureInstagramScript();
        var blockquote = document.createElement("blockquote");
        blockquote.className = "instagram-media";
        blockquote.setAttribute("data-instgrm-captioned", "false");
        blockquote.setAttribute("data-instgrm-permalink", "https://www.instagram.com/reel/" + parsed.id + "/");
        blockquote.style.background = "#000";
        blockquote.style.margin = "0 auto";
        blockquote.style.minWidth = "320px";
        blockquote.style.maxWidth = "100%";
        embed.appendChild(blockquote);

        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      } else if (parsed.type === "tiktok") {
        ensureTikTokScript();
        var iframe = document.createElement("iframe");
        iframe.src = "https://www.tiktok.com/embed/v2/" + parsed.id;
        iframe.title = "TikTok video";
        iframe.allow = "encrypted-media; picture-in-picture";
        iframe.setAttribute("allowfullscreen", "true");
        iframe.style.width = "100%";
        iframe.style.height = "70vh";
        embed.appendChild(iframe);
      } else {
        var genericIframe = document.createElement("iframe");
        genericIframe.src = parsed.url;
        genericIframe.title = "Video embed";
        genericIframe.allow = "encrypted-media; picture-in-picture";
        genericIframe.setAttribute("allowfullscreen", "true");
        genericIframe.style.width = "100%";
        genericIframe.style.height = "70vh";
        embed.appendChild(genericIframe);
      }

      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    sectionEl.querySelectorAll("[data-m2-kol-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        openLightbox(trigger.getAttribute("data-video-url"));
      });
    });

    initKolMobileCarousel(sectionEl);

    closeBtn.addEventListener("click", closeLightbox);
    lightbox.addEventListener("click", function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && lightbox.classList.contains("is-open")) {
        closeLightbox();
      }
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target || !event.target.querySelector) return;
    var wrap = event.target.querySelector("[data-m2-kol-section]");
    if (!wrap) return;
    var grid = wrap.querySelector(".m2-kol-grid");
    if (grid) delete grid.dataset.m2KolCarouselBound;
    initKolMobileCarousel(wrap);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
